import request from '@/utils/request'

const userApi = {
    ConfigSignature: '/api/ConfigSignature',
    AgentConfigSignature: '/api/AgentConfigSignature',
    getCorUserId: '/api/getCorUserId',
    UserInfoByUserId: '/api/returnCustomerInfo',
    QwExportEc:'/api/QwExportEc',
    SendMassageEc:'/api/SendMassageEc'
}

export function ConfigSignature (parameter) {
    return request({
      url: userApi.ConfigSignature,
      method: 'post',
      data: parameter
    })
}

export function AgentConfigSignature (parameter) {
    return request({
      url: userApi.AgentConfigSignature,
      method: 'post',
      data: parameter
    })
}

export function getCorUserId (parameter) {
    return request({
      url: userApi.getCorUserId,
      method: 'post',
      data: parameter
    })
}

export function UserInfoByUserId (parameter) {
    return request({
      url: userApi.UserInfoByUserId,
      method: 'post',
      data: parameter
    })
}

export function QwExportEc (parameter) {
    return request({
      url: userApi.QwExportEc,
      method: 'post',
      data: parameter
    })
}

export function SendMassageEc (parameter) {
  return request({
    url: userApi.SendMassageEc,
    method: 'post',
    data: parameter
  })
}